import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import BreadcrumbsController from './BreadcrumbsController';
import { getLocalizedName } from '../../helpers';
import Icon from '@projeccions-pdc/react-icon';
import queryString from 'query-string';
import { isSmartphone } from '../../helpers';
import './Breadcrumbs.css';
import AppContext from '../../AppContext';
import { CollectionIcon, MeetingsIcon } from '../Search/Search';
class Breadcrumbs extends Component {
    constructor(props) {
        super(props);
        // let contentId = undefined;
        // if ([undefined, 'category', 'metadocument'].indexOf(props.match.params.func) !== -1) {
        //     contentId = props.match.params.contentId;
        //     if (contentId && contentId.indexOf('$') !== -1) {
        //         let aux = contentId.split('$');
        //         contentId = aux[0];
        //     }
        // }
        // let breadcrumbs = undefined;
        // if (props.preDefinedPath && (props.preDefinedPath[0].contentId === contentId)) {
        //     breadcrumbs = props.preDefinedPath.reverse();
        // }
        this.state = {
            // contentId,
            // breadcrumbs
        };

        this._BreadcrumbsController = new BreadcrumbsController(this);
    }

    handleSizeChange = (match) => {
        this.setState({ smartphoneView: match });
    };

    componentDidMount() {
        isSmartphone((match) => this.handleSizeChange(match));
    }

    static getDerivedStateFromProps(props, state) {
        let newState = null;

        let contentId = undefined;
        if ([undefined, 'category', 'metadocument'].indexOf(props.match.params.func) !== -1) {
            contentId = props.match.params.contentId;
        } else if (['fileviewer', 'library'].indexOf(props.match.params.func) !== -1) {
            contentId = state.contentId;
        }

        if (contentId && contentId.indexOf('$') !== -1) {
            let aux = contentId.split('$');
            contentId = aux[0];
        }

        if (state.contentId !== contentId) {
            newState = Object.assign({}, newState, {
                contentId,
                oldContentId: state.contentId,
            });
        }

        if (props.preDefinedPath && props.preDefinedPath[0].contentId === contentId) {
            let breadcrumbs = props.preDefinedPath.reverse();
            newState = Object.assign({}, newState, {
                breadcrumbs,
            });
        }

        const parsed = queryString.parse(props.location.search);
        if (parsed.mtg) {
            newState = Object.assign({}, newState, {
                mtg: parsed.mtg,
            });
        }
        if (parsed.col) {
            newState = Object.assign({}, newState, {
                col: parsed.col,
            });
        }

        return newState;
    }

    componentDidUpdate() {
        if (this.state.oldContentId !== this.state.contentId) {
            this.loadData();
        }
    }

    loadData = async () => {
        let newState = await this._BreadcrumbsController.loadBaseData(this.state.contentId, this.props.inside, this.state.breadcrumbs);
        this.setState(newState);
    };

    render() {
        let smartphoneStyle = {
            display: 'inline-block',
            color: '#000',
            width: '30px',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
        };
        let normalStyle = {
            display: 'inline-block',
            color: '#000',
        };

        let appContext = new AppContext();
        let language = appContext.getLanguage();
        return (
            <div className={this.state.mtg || this.state.col ? 'fe-breadcrumbs fe-breadcrumbs-meetings' : 'fe-breadcrumbs'}>
                {this.state.mtg ? (
                    <Link to={`/metadocument/show/${this.state.mtg}`}>
                        <div className="fe-breadcrumbs-home">
                            <div style={{ verticalAlign: 'middle', display: 'inline-block' }}>
                                <Icon name={MeetingsIcon} size={'25px'} />
                            </div>
                        </div>
                    </Link>
                ) : this.state.col ? (
                    <Link to={`/metadocument/show/${this.state.col}`}>
                        <div className="fe-breadcrumbs-home">
                            <div style={{ verticalAlign: 'middle', display: 'inline-block' }}>
                                <Icon name={CollectionIcon} size={'25px'} />
                            </div>
                        </div>
                    </Link>
                ) : (
                    <Link to={this.props.inside ? '/category/show/' : '/category/edit/'}>
                        <div className="fe-breadcrumbs-home">
                            <div style={{ verticalAlign: 'middle', display: 'inline-block' }}>
                                <Icon name="md-list" size={'25px'} />
                            </div>
                        </div>
                    </Link>
                )}
                {this.state.contentId
                    ? this.state.breadcrumbs
                        ? this.state.breadcrumbs.map((content, idx, array) => {
                              if (content.contentId === 'MAIN-CATEGORY') {
                                  return null;
                              }
                              return (
                                  <div style={{ display: 'inline-block' }} key={content.contentId}>
                                      <div className="fe-breadcrumbs-item-spacer">
                                          <Icon name="fa-angle-right" size={'25px'} primaryColor={'rgb(83,83,83)'} />
                                      </div>
                                      <Link
                                          to={
                                              this.props.inside
                                                  ? content.objectType === 'c'
                                                      ? '/category/show/' + content.contentId
                                                      : '/metadocument/show/' + content.contentId
                                                  : content.objectType === 'c'
                                                  ? '/category/edit/' + content.contentId
                                                  : '/metadocument/edit/' + content.contentId
                                          }
                                      >
                                          <div
                                              className={
                                                  content.objectType === 'c'
                                                      ? 'fe-breadcrumbs-item fe-breadcrumbs-category'
                                                      : 'fe-breadcrumbs-item'
                                              }
                                          >
                                              <div
                                                  dangerouslySetInnerHTML={{ __html: getLocalizedName(language, content.names) }}
                                                  style={
                                                      this.state.smartphoneView !== true || idx === array.length - 1
                                                          ? normalStyle
                                                          : smartphoneStyle
                                                  }
                                              />
                                          </div>
                                      </Link>
                                  </div>
                              );
                          })
                        : ''
                    : ''}
            </div>
        );
    }
}
Breadcrumbs.propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    inside: PropTypes.bool.isRequired,
    contentId: PropTypes.string,
    preDefinedPath: PropTypes.array,
};
Breadcrumbs.contextTypes = {
    router: PropTypes.shape({
        history: PropTypes.shape({
            push: PropTypes.func.isRequired,
            replace: PropTypes.func.isRequired,
        }).isRequired,
        staticContext: PropTypes.object,
    }).isRequired,
};

export default Breadcrumbs;
